// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"49f67824","455":"84bdc1d9","977":"5e63e35c"}[chunkId] + ".chunk.js";
};